module.exports = __webpack_public_path__ + "media/images/navbar-logo-90d777194fcd4c7b5e4c4922e514522b.webp";